import {
  AppBar,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import { PartDetails } from "../../../../explorer/types/SpareParts/PartDetails";
import {
  BoxImagePreview,
  ContainerInfoPreview,
  ContainerInputNumber,
  ContainerTextCart,
  ContainerUom,
  InputQuantity,
  NoResults,
  Unity,
} from "./PartDetails.style";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";
import { useEffect, useState } from "react";
import { useReduxState } from "../../../../explorer/redux/hooks";
import { Basket } from "../../../../explorer/types";
import AppIconButtonInt from "../../AppButtons/AppIconButtonInt";
import AppIconButtonPrimary from "../../AppButtons/AppIconButtonPrimary";
import {
  AppIconsRemove,
  AppIconsAdd,
  AppIconsCart,
  AppIconsClose,
} from "../../AppIcons";
import DrawerPartDetailsBaskets from "../DrawerPart/DrawerPartDetailsBaskets";
import ServiceProvider from "../../../configuration/ServiceProvider";
import { BasketItemDTO } from "../../../../explorer/types/Basket/BasketItems";
import { CommonSnackbar } from "../../../../explorer/components/SnackBar/CommonSnackbar";
import { Machine } from "../../../../explorer/types/SpareParts";
import { PartDetailsProps } from "../PartDetailsProps";
import { useBasket } from "../../../hook/useBasket";
import { useParams } from "react-router";
import MagnifierImage from "../../MagnifierImage/MagnifierImage";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { PARTS_RESOURCES } from "../../../configuration/Resources";
import { StyleguideSavioColors } from "../../../configuration/themeSettings";
import { usePartDetails } from "../../../hook/usePartDetails";
import { usePartFormatter } from "../../../hook/usePartFormatter";

type PartDetailsInfoProps = PartDetails & { replacedCode?: string | undefined };

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PartDetailsInfo: React.FC<
  React.PropsWithChildren<PartDetailsInfoProps>
> = (props: React.PropsWithChildren<PartDetailsInfoProps>) => {
  const partDetails = props;

  const { machineId } = useParams();
  const { closePartDetails } = usePartDetails();

  const [qtyValue, setQtyValue] = useState<number | string>(1);
  const currentBasket = useBasket().currentBasket;
  const [selectedBasket, setSelectedBasket] = useState<Basket>(currentBasket);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [response, setResponse] = useState<{
    text: string;
    error: boolean;
  }>();

  const [currentMachine] = useReduxState<Machine>(
    reduxStoreConfig.sparePartsCurrentMachine
  );
  const [partDetailsProps] = useReduxState<PartDetailsProps>(
    reduxStoreConfig.sparePartsPartDetails
  );

  const { t } = useTranslation();
  const showDetails = partDetails.id;

  useEffect(() => {
    setSelectedBasket(currentBasket);
  }, [currentBasket]);

  const handleDecrease = () => {
    // Non può andare sotto al minQty
    if (Number(qtyValue) > 1) setQtyValue((prevValue) => Number(prevValue) - 1);
  };

  const handleIncrese = () => {
    if (Number(qtyValue) < 1) setQtyValue(1);
    setQtyValue((prevValue) => Number(prevValue) + 1);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    var newValue = e.target.value;

    const re = /^0/;

    if (re.test(newValue)) {
      newValue = newValue.substring(1);
    }

    if (!newValue || Number(newValue) >= 1) {
      setQtyValue(newValue);
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const re = /^[0-9]$/;

    // Tasti consentiti aggiuntivi
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete"];

    // Verifica se il tasto premuto è un numero o un tasto consentito
    if (!re.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault(); // Blocca l'input se non è valido
      return;
    }
  };

  // Se si lascia il numero 0, viene sostituito con 1
  const handleBlur = () => {
    if (Number(qtyValue) < 1) {
      setQtyValue(1);
    }
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  // Se isReplaced è true, i codici PartCode e LastReplacementPartCode si invertono di posizione
  const isReplaced = props.replacedCode ? true : false;
  const partFormatter = usePartFormatter();

  const AddPartToSelectedBasket = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    const part: BasketItemDTO = {
      basketId: selectedBasket.id,
      qty: Number(qtyValue),
      code: partDetails.code,
      replacedCode: isReplaced ? props.replacedCode : undefined,
      manufacturerCompanyCode: partDetails.manufacturerCompanyCode,
      navContext:
        partDetailsProps.navContext !== undefined
          ? partDetailsProps.navContext
          : machineId !== undefined
          ? partFormatter.setNavContextByData(
              currentMachine.serialNumber ?? "",
              partDetailsProps.parentNaturalKey ?? "",
              partDetailsProps.position ?? ""
            )
          : "",
    };

    ServiceProvider.Basket.AddBasketItem(part)
      .then((response) => {
        setResponse({
          text: t("common.basket.itemAdded"),
          error: false,
        });

        if (partDetailsProps.navContext !== undefined) {
          closePartDetails(true);
        }
      })
      .catch((errors) => {
        console.error(errors);
        setResponse({
          text: errors.map((e: { errorCode: string | undefined }) =>
            t(`basket.items.${e.errorCode}`)
          ),
          error: true,
        });
      });
  };

  return (
    <>
      {showDetails && (
        <Box
          sx={{
            padding: "17px 50px",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
          display={"flex"}
        >
          <MagnifierImage
            src={
              partDetails?.partImages && partDetails?.partImages?.length > 0
                ? `${PARTS_RESOURCES}/${partDetails?.partImages[0].fileName?.substring(
                    0,
                    2
                  )}/${partDetails?.partImages[0].fileName}.thumb.300.jpg`
                : "/img/imageNotAvailableWhite.svg"
            }
            width={200}
            height={200}
            onClick={handleOpenDialog}
            disabled={partDetails?.partImages?.length === 0}
          />

          <ContainerInfoPreview
            display="flex"
            flexDirection="column"
            flexGrow={1}
          >
            <Box>
            {props.showBasket && (<>
              <ContainerTextCart>
                <span>{t("common.spareparts.selectedBasket")}</span>
                <span>{selectedBasket.name}</span>
                <DrawerPartDetailsBaskets
                  setSelectedBasket={setSelectedBasket}
                />
              </ContainerTextCart>

              <ContainerInputNumber>
                <div
                  style={{
                    width: 120,
                    display: "flex",
                    marginRight: 10,
                  }}
                >
                  <AppIconButtonInt onClick={handleDecrease}>
                    <AppIconsRemove />
                  </AppIconButtonInt>
                  <InputQuantity
                    value={qtyValue}
                    type="number"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    onPaste={(e) => e.preventDefault()}
                    sx={{"input":{pb:'0 !important',}}}
                  />
                  <AppIconButtonInt onClick={handleIncrese}>
                    <AppIconsAdd />
                  </AppIconButtonInt>
                </div>
                <ContainerUom>{partDetails.salesUnitOfMeasure}</ContainerUom>
                <AppIconButtonPrimary sx={{ml: '10px',}} onClick={AddPartToSelectedBasket}>
                  <AppIconsCart />
                </AppIconButtonPrimary>
              </ContainerInputNumber>
              </>)}

              {/*<Typography>{partDetails.salesUnitOfMeasure}</Typography>*/}
            </Box>
          </ContainerInfoPreview>
          {response && (
            <CommonSnackbar
              open={response !== undefined}
              message={response!.text}
              messageType={response!.error ? "error" : "success"}
              onClose={() => {
                setResponse(undefined);
              }}
            />
          )}

          <Dialog
            open={openDialog}
            fullScreen
            onClose={handleCloseDialog}
            TransitionComponent={Transition}
          >
            <DialogTitle sx={{ backgroundColor: "transparent !important" }}>
              <AppBar
                sx={{
                  backgroundColor: "transparent",
                  boxShadow: "none",
                }}
              >
                <Toolbar sx={{ justifyContent: "flex-end" }}>
                  <IconButton
                    edge="end"
                    onClick={handleCloseDialog}
                    aria-label="close"
                    sx={{
                      color: StyleguideSavioColors.darkBlue + " !important",
                    }}
                  >
                    <AppIconsClose />
                  </IconButton>
                </Toolbar>
              </AppBar>
            </DialogTitle>
            <DialogContent
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MagnifierImage
                src={
                  partDetails?.partImages && partDetails?.partImages?.length > 0
                    ? `${PARTS_RESOURCES}/${partDetails?.partImages[0].fileName?.substring(
                        0,
                        2
                      )}/${partDetails?.partImages[0].fileName}.thumb.300.jpg`
                    : "/img/imageNotAvailableWhite.svg"
                }
                width={450}
                height={450}
              />
            </DialogContent>
          </Dialog>
        </Box>
      )}
      {!showDetails && (
        <NoResults>
          {t("common.spareparts.searchpage.results.title.no_results")}
        </NoResults>
      )}
    </>
  );
};

export default PartDetailsInfo;
